import { render, staticRenderFns } from "./MessageAttachment.vue?vue&type=template&id=d60c7aba&scoped=true"
import script from "./MessageAttachment.vue?vue&type=script&lang=js"
export * from "./MessageAttachment.vue?vue&type=script&lang=js"
import style0 from "./MessageAttachment.vue?vue&type=style&index=0&id=d60c7aba&prod&lang=scss&scoped=true"
import style1 from "./MessageAttachment.vue?vue&type=style&index=1&id=d60c7aba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60c7aba",
  null
  
)

export default component.exports